module.exports = __webpack_public_path__ + "img/gift_bt_img.ecb77c76.svg";